import apiClient from './apiClient';

export type AcceptanceChangeContextType = 'form' | 'field' | 'formula' | 'workflow' | 'permission' | 'side_effect';

export interface AcceptanceChangeRequestPayload {
  formId: string;
  chainId: string;
  contextType: AcceptanceChangeContextType;
  fieldId?: string;
  controlId?: string;
  contractHash: string;
  documentKey?: string;
  acceptanceRunId?: string;
  correlationId?: string;
  environment?: string;
  roleContext?: string;
  inputSummary?: unknown;
  evidenceContext?: unknown;
  expectedBehavior: string;
  attachmentRefs?: string[];
}

export interface AcceptanceChangeRequest extends AcceptanceChangeRequestPayload {
  requestId: number;
  status: string;
  submittedBy: string;
  submittedAt: string;
  updatedBy: string;
  updatedAt: string;
}

export const acceptanceChangeRequestApi = {
  async create(payload: AcceptanceChangeRequestPayload) {
    return (await apiClient.post<AcceptanceChangeRequest>('/api/acceptance/change-requests', payload)).data;
  },
  async list(formId?: string, status?: string) {
    return (await apiClient.get<{ data: AcceptanceChangeRequest[] }>('/api/acceptance/change-requests', {
      params: { formId, status, limit: 100 },
    })).data.data;
  },
  async transition(requestId: number, status: string, note = '') {
    return (await apiClient.put<AcceptanceChangeRequest>(
      `/api/acceptance/change-requests/${requestId}/status`,
      { status, note },
    )).data;
  },
};
